<template>
  <b-modal
    :id="modalId"
    title="Detalhes da Transação"
    size="sm"
    centered
    hide-footer
    header-bg-variant="primary"
    header-text-variant="light"
  >
    <div v-if="data" class="details-wrapper">

      <div class="detail-row" v-if="data.ec">
        <span class="label">EC</span>
        <span class="value">{{ data.ec }}</span>
      </div>

      <div class="detail-row" v-if="data.nsu">
        <span class="label">NSU</span>
        <span class="value">{{ data.nsu }}</span>
      </div>

      <div class="detail-row" v-if="data.transaction_date">
        <span class="label">Data</span>
        <span class="value">{{ formatDate(data.transaction_date) }}</span>
      </div>

      <div class="detail-row" v-if="data.gross_amount !== undefined">
        <span class="label">Valor</span>
        <span class="value">{{ formatCurrency(data.gross_amount) }}</span>
      </div>

      <div class="detail-row" v-if="data.platform_type">
        <span class="label">Plataforma</span>
        <span class="value">{{ data.platform_type }}</span>
      </div>

      <div class="detail-row" v-if="data.installment_quantity">
        <span class="label">Parcelas</span>
        <span class="value">{{ data.installment_quantity }}x</span>
      </div>

      <div class="detail-row" v-if="data.brand">
        <span class="label">Bandeira</span>
        <span class="value text-capitalize">{{ data.brand }}</span>
      </div>

      <div class="detail-row" v-if="data.status">
        <span class="label">Status</span>
        <span class="value">
          <b-badge :variant="statusVariant">
            {{ data.status }}
          </b-badge>
        </span>
      </div>

    </div>
  </b-modal>

</template>

<script>
import { BModal, BRow, BCol, BBadge } from "bootstrap-vue";

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BBadge,
  },
  props: {
    modalId: {
      type: String,
      default: "transaction-details-modal",
    },
    data: {
      type: Object,
      default: null,
    },
  },
  computed: {
    statusVariant() {
      if (!this.data?.status) return "secondary";

      const status = this.data.status.toLowerCase();

      const map = {
        processando: "warning",
        autorizado: "success",
        cancelado: "danger",
        pago: "success",
        recusado: "danger",
        chargeback: "info",
        antecipado: "warning",
        vencido: "dark",
        pendente: "warning",
        análise: "info",
        "prz. venci": "warning",
        "prz. conte": "secondary",
        cedido: "info",
        "em contestação": "secondary",
        "antecipação autorizada": "success",
      };

      return map[status] || "secondary";
    },
  },

  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    },
    formatCurrency(value) {
      return Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>
<style scoped>
.modal-header {
  background-color: #007bff !important;
  color: #fff !important;
  border-bottom: none;
  padding: 1.2rem 1.5rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.modal-header .modal-title {
  color: #ffffff !important;
}

::v-deep .modal-header .modal-title {
  color: #ffffff !important;
}

.details-wrapper {
  padding: 1.3rem 1.6rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 0.55rem 0;
  border-bottom: 1px solid #eee;
  font-size: 0.95rem;
}

.detail-row:last-child {
  border-bottom: none;
}

.label {
  font-weight: 600;
  color: #555;
}

.detail-row.highlight .label {
  color: #2d3748;
}

.detail-row.highlight .value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2d3748;
}

.badge {
  padding: 0.45rem 0.65rem;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 6px;
}
::v-deep .modal-header .close {
  color: #db2424 !important;
  text-shadow: none !important;
  opacity: 1 !important;
}
</style>